{
  "messages": {
    "unknown": "Ukjent feil",
    "unwellEnvironment": "Du har blitt logget ut eller mistet kontakten med systemet. Prøv å logge inn på nytt.",
    "errorTitle": "Det har oppstått en feil!",
    "unknownErrorAdminInfo": "Det har oppstått en ukjent feil, eller en feil uten feilmelding. Kontakt systemadministratoren.",
    "someError": "Noe gikk galt",
    "nameMissing": "Navn mangler",
    "nothingFound": "Ingenting ble funnet",
    "articleMissingTitle": "Artikkeldokumentet mangler",
    "articleMissingDescription": "Ingen artikkeldokument er oppgitt. Gå tilbake til oversikten og forsøk igjen.",
    "embeddedFactboxMissing": "Faktaboksen kunne ikke oppnes. Gå tilbake til oversikten og forsøk igjen.",
    "failedFetchingDocument": "Kunne ikke hente dokument.",
    "failedUpdatingListRetrying": "Kunne ikke oppdatere listen automatisk. Prøver på nytt om {{seconds}} sekunder.",
    "noResultsFound": "Ingen resultater funnet",
    "copyError": "Kopier feilmelding",
    "validationError": "Valideringsfeil",
    "documentTypeMissing": "{{documentType}} mangler",
    "documentTypeMissingDescription": "Inget {{documentType, lowercase}} er oppgitt. Naviger tilbake til oversikten og forsøk igjen.",
    "couldNotCreateNewFactbox": "Det gikk ikke å opprette ny faktaboks!",
    "statusChangeforDocumentTypeFailed": "Kunne ikke endre status på {{documentType, lowercase}}! Det gikk ikke å finne en koblet plan.",
    "scheduleArticleFailed": "Kunne ikke planlegge artikkelen! Tid eller dato angitt feil.",
    "createQuickArticleFailed": "Feil ved oppretting av hurtigartikkel.",
    "flashCreationFailed": "HAST kunne ikke opprettes.",
    "createAssignmentError": "HAST er opprettet. Dessverre klarte den ikke å koble til en tidsplan.",
    "failedToLoadHistory": "Det oppsto en feil under henting av dokumenthistorikken.",
    "failedToLoadMetaData": "Det oppsto en feil under henting av metadata.",
    "saveAssignmentError": "Kunne ikke lagre oppdraget",
    "createDeliverableError": "Kan ikke opprette leveransen",
    "changeStatusError": "Statusen kunne ikke endres. Oppgavens publiseringstidspunkt kunne ikke endres i den lenkede planen.",
    "loadFailed": "Kunne ikke laste",
    "noDeliverables": "Ingen leveranser",
    "documentCreationFailed": "{{type}} kunne ikke opprettes.",
    "documentCreatedAssignmentFailed": "{{type}} har blitt opprettet. Dessverre mislyktes det å koble den til en plan.",
    "planningSectionMissing": "Finner ikke plankategorien for den valgte planen. Prøv å logge ut og inn på nytt.",
    "planningLackingSection": "Den valgte planen mangler plankategori. Legg til en plankategori i den valgte planen."
  },
  "toasts": {
    "couldNotCreateNewEvent": "Kunne ikke opprette ny hendelse!",
    "couldNotCreateNewPlanning": "Kunne ikke opprette ny plan!",
    "snapshotError": "Planen er endret lokalt, men kunne ikke lagres.",
    "createDeliverableLinkError": "Kunne ikke koble til leveransen",
    "saveError": "Kunne ikke lagre planen",
    "saveChangeError": "Kunne ikke lagre endringen",
    "missingMetadata": "Mangler nyhetsverdi eller kategori",
    "missingTimelessCategory": "Mangler tidløs kategori",
    "assignmentMoveError": "Oppdraget kunne ikke flyttes",
    "assignmentMoveErrorNotLoggedIn": "Oppdraget kunne ikke flyttes. Du er ikke logget inn.",
    "assignmentMoveErrorTryAgain": "Oppdraget kunne ikke flyttes. Vennligst prøv igjen.",
    "couldNotSaveAfterMove": "Kunne ikke lagre etter flytting.",
    "getPlanningsFailed": "Kunne ikke hente planer",
    "getEventsFailed": "Kunne ikke hente hendelser",
    "getSearchResultsFailed": "Kunne ikke hente søkeresultatene",
    "unableToAutorise": "Kan ikke autentisere til bildetjenesten",
    "showPictureFailed": "Kan ikke vise bildet, ugyldig id",
    "sendDataError": "Kunne ikke sende data",
    "multipleAuthors": "Flere forfatterdokumenter funnet, kontakt support",
    "unpublishError": "Kunne ikke avpubliser dokumentet",
    "addAssignmentToPlanningError": "Oppgaven kunne ikke legges til i en koblet tidsplan.",
    "creationFailed": "Kunne ikke opprette tekst: {{error}}",
    "fetchDocumentFailed": "Kunne ikke hente dokument",
    "couldNotScheduleArticle": "Kunne ikke planlegge artikkelen! Tid eller dato angitt feil.",
    "savedDocumentFailed": "Kunne ikke lagre dokument",
    "fetchStatusFailed": "Det oppsto en feil under henting av gjeldende status. Prøv å laste inn siden på nytt.",
    "couldNotChangeStatusReloadBrowser": "Det har oppstått en feil. Gjeldende status kunne ikke endres! Last inn nettleseren på nytt og prøv på nytt.",
    "couldNotChangeStatus": "Det oppstod en feil når aktuell status skulle endres.",
    "couldNotSaveStatus": "Det oppstod en feil når aktuell status skulle lagres.",
    "failedToFillArticleHeadline": "Overskriften kunne ikke fylles inn automatisk. Oppgavens tittel brukes likevel som artikkelens tittel.",
    "couldNotFindPlanningSection": "Finner ikke plankategorien",
    "authorUpdateFailure": "Kunne ikke oppdatere forfatterdokumentet: {{errorMessage}}",
    "authorSaveFailure": "Kunne ikke lagre forfatterdokumentet: {{errorMessage}}",
    "authorCreateFailure": "Kunne ikke opprette forfatterdokument: Failed to create author doc",
    "authorCreateUndefinedFailed": "Kunne ikke opprette forfatterdokument: Failed to fetch author document: undefined",
    "couldNotOpenEmbeddedFactbox": "Kunne ikke åpne den faktaboksen. Vennligst naviger tilbake til oversikten og prøv igjen.",
    "couldNotLoadFactbox": "Kunne ikke laste faktaboksen. Vennligst prøv igjen."
  },
  "systemMessages": {
    "connectionFailed": "Kunne ikke koble til meldingstjenesten. Last inn vinduet på nytt."
  }
}
